import "../css/header.scss";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [moreOpen, setMoreOpen] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-left">
        <Link to="/" className="logo" onClick={toTop}>
          <span className="logo-mark" aria-hidden="true">p</span>
          <span className="logo-wordmark">pmistpearl</span>
        </Link>
      </div>
      <div className="header-right">
        <Link to="/about" className="nav-link" onClick={toTop}>
          OUR STORY
        </Link>
        <Link to="/contact" className="nav-link" onClick={toTop}>
          CONTACT US
        </Link>
        <Link to="/shop" className="nav-link" onClick={toTop}>
          PEARL GOODS
        </Link>
        <div className="more-menu">
          <button className="nav-link more-toggle" type="button" onClick={() => setMoreOpen((open) => !open)} aria-expanded={moreOpen}>
            MORE
          </button>
          {moreOpen && (
            <div className="more-dropdown">
              <Link to="/privacy" onClick={toTop}>PRIVACY</Link>
              <Link to="/cookies" onClick={toTop}>COOKIES</Link>
              <Link to="/faqs" onClick={toTop}>FAQS</Link>
              <Link to="/terms" onClick={toTop}>TERMS</Link>
            </div>
          )}
        </div>
        <Link to="/cartpage" className="nav-link" onClick={toTop}>
          CART ({cartItems ? cartItems.length : 0})
        </Link>
      </div>
    </header>
  );
}

export default Header;
